import { CDK_ACCORDION, CdkAccordion } from '@angular/cdk/accordion';
import { Component, computed, HostBinding, inject, InjectionToken, input, Signal } from '@angular/core';
import { GALAXY_LIST_OPTIONS_TOKEN } from './list.config';

interface ListContainer {
  designVersion: Signal<'default' | 'legacy'>;
}

export const GALAXY_LIST_CONTAINER_TOKEN = new InjectionToken<ListContainer>('GalaxyListContainerToken');

@Component({
  selector: 'glxy-list-container',
  templateUrl: './list-container.component.html',
  styleUrls: ['./list-container.component.scss'],
  providers: [
    { provide: CDK_ACCORDION, useExisting: GalaxyListContainerComponent },
    { provide: GALAXY_LIST_CONTAINER_TOKEN, useExisting: GalaxyListContainerComponent },
  ],

  host: {
    role: 'list',
    '[class.glxy-list-container-default]': 'designVersion() === "default" || !designVersion()',
    '[class.glxy-list-container-legacy]': 'designVersion() === "legacy"',
  },
})
export class GalaxyListContainerComponent extends CdkAccordion {
  private readonly injectedDesignVersion = inject(GALAXY_LIST_OPTIONS_TOKEN, { optional: true })?.designVersion;

  @HostBinding('class.glxy-list-container') protected class = true;

  readonly useDesignVersion = input<undefined | 'legacy' | 'default'>();
  readonly designVersion = computed(() => {
    return this.useDesignVersion() ?? this.injectedDesignVersion ?? 'default';
  });
}
